const routes = [
  {
    path: ["/", "/home"],
    exact: true,
    component: "Home",
  },
  {
    path: ["/volunteer"],
    exact: true,
    component: "Volunteer",
  },
  {
    path: ["/donate"],
    exact: true,
    component: "Donate",
  },
  {
    path: ["/circle-time"],
    exact: true,
    component: "CircleTime",
  },
  {
    path: ["/get-involved"],
    exact: true,
    component: "GetInvolved",
  },
  {
    path: ["/mission"],
    exact: true,
    component: "Mission",
  },
  {
    path: ["/nutrition"],
    exact: true,
    component: "Nutrition",
  },
  {
    path: ["/story"],
    exact: true,
    component: "Story",
  },
  {
    path: ["/team"],
    exact: true,
    component: "Team",
  },
  {
    path: ["/impact"],
    exact: true,
    component: "Impact",
  },
  {
    path: ["/philosophy"],
    exact: true,
    component: "Philosophy",
  },
  {
    path: ["/sleep"],
    exact: true,
    component: "Sleep",
  },
  {
    path: ["/spirituality"],
    exact: true,
    component: "Spirituality",
  },
  {
    path: ["/supplements"],
    exact: true,
    component: "Supplements",
  },
  {
    path: ["/training"],
    exact: true,
    component: "Training",
  },
  {
    path: ["/about"],
    exact: true,
    component: "About",
  },
  {
    path: ["/privacy-policy"],
    exact: true,
    component: "PrivacyPolicy",
  },
];

export default routes;
